import React from 'react';
import { motion } from 'framer-motion';
export function SocialProofSection() {
  return <section className="bg-warm-gray py-12 md:py-16 px-4" data-id="element-98">
      <div className="max-w-3xl mx-auto" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-emerald-deep mb-4" data-id="element-101">
            Resultados Reales
          </h2>
          <p className="text-gray-600 font-body" data-id="element-102">
            Lo que dicen las personas que ya iniciaron su reinicio.
          </p>
        </motion.div>

        <div className="bg-[#efeae2] p-4 md:p-8 rounded-3xl shadow-inner max-w-md mx-auto relative overflow-hidden" data-id="element-103">
          {/* WhatsApp Background Pattern */}
          <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'url("https://w0.peakpx.com/wallpaper/818/148/HD-wallpaper-whatsapp-background-cool-dark-green-new-theme-whatsapp.jpg")',
          backgroundSize: 'cover'
        }} data-id="element-104"></div>

          <div className="relative z-10 space-y-6" data-id="element-105">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="wa-bubble left" data-id="element-106">
              <p data-id="element-107">
                Día 4 y la neblina se fue por completo. ¡Es ciencia pura! ✨
              </p>
              <span className="wa-time" data-id="element-108">10:42 AM • Lucía, Sevilla</span>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="wa-bubble left" data-id="element-109">
              <p data-id="element-110">
                Mi pantalón ya no me aprieta al final del día. Gracias equipo
                Zeklo. 🙌
              </p>
              <span className="wa-time" data-id="element-111">14:15 PM • Paco, Madrid</span>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}